import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredFutureDate } from '@/utils/zodUtils';

export const UpdateDueDateSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      dueDate: requiredFutureDate(t),
    })
    .strict();

export type UpdateDueDateType = z.infer<ReturnType<typeof UpdateDueDateSchema>>;
